export const WHITELIST_END_TIME = "2025-11-19T12:00:00Z";

export const TOTAL_WHITELIST = 9999;
